import React, {useEffect, useMemo, useState} from 'react';
import PieChart from '../../charts/PieChart'
import BlockChart from "../../BlockChart";
import {useTranslation} from "react-i18next";


const ConsentOutputChart = ( {data = [], isSuccess, isFetching: isLoading, refetch} ) => {
  const { t } = useTranslation();
  const formatData = (data) => (
    data.map(el => (
      {
        y: el.count,
        name: t(`cmp.analytics.${el.final_action}`)
      }
    ))
  )
  const dataWithActionsTranslated = useMemo(() => (formatData(data)), [data])
  return (
    <BlockChart title={t("cmp.analytics.consentsByOutput")} isLoading={isLoading} isSuccess={isSuccess}>
      <PieChart data={dataWithActionsTranslated}/>
    </BlockChart>
  )
}

export default ConsentOutputChart
